/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UptimePreferenceRequest
 */
export interface UptimePreferenceRequest {
    /**
     *
     * @type {boolean}
     * @memberof UptimePreferenceRequest
     */
    value?: boolean;
}

/**
 * Check if a given object implements the UptimePreferenceRequest interface.
 */
export function instanceOfUptimePreferenceRequest(
    value: object,
): value is UptimePreferenceRequest {
    return true;
}

export function UptimePreferenceRequestFromJSON(
    json: any,
): UptimePreferenceRequest {
    return UptimePreferenceRequestFromJSONTyped(json, false);
}

export function UptimePreferenceRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UptimePreferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        value: json["value"] == null ? undefined : json["value"],
    };
}

export function UptimePreferenceRequestToJSON(
    value?: UptimePreferenceRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        value: value["value"],
    };
}
